<template>
  <div class="vue-input-tag-wrapper">
    <input class="new-tag tb-input" type="text" ref="tags" v-bind:placeholder="placeholder" v-model="tag" v-on:keyup.right.stop v-on:keyup.left.stop  v-on:keydown.delete="removeLast($event)" v-on:keydown.enter.space="add($event)">
    <span class="input-tag" v-for="(tag, index) in tags"><span>{{tag}}</span><a v-on:click.stop.prevent="remove(tag)" class="remove pull-right margin-left-xs"><span class="icon icon-cross"></span></a></span>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Search',
    },
    tags: Array,
  },
  data() {
    return {
      tag: '',
    };
  },
  methods: {
    focus() {
      this.$refs.tags.focus();
    },
    add($event) {
      const term = this.tag.trim();
      if (term.length && this.tags.indexOf(term) === -1) {
        this.$emit('add', term);
        this.tag = '';
      }
      $event.preventDefault();
    },
    remove(tag) {
      this.$emit('remove', tag);
    },
    removeLast() {
      const $el = $(this.$el);

      if (!$el.find('.new-tag').val().length) { // Vue being dumb, jquery works better
        this.$emit('remove', this.tags[this.tags.length - 1]);
      }
    },
  },
};
</script>
